import { render, staticRenderFns } from "./FileLocationFormAdd.vue?vue&type=template&id=37d8cb6b&scoped=true&"
import script from "./FileLocationFormAdd.vue?vue&type=script&lang=js&"
export * from "./FileLocationFormAdd.vue?vue&type=script&lang=js&"
import style0 from "./FileLocationFormAdd.vue?vue&type=style&index=0&id=37d8cb6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8cb6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VFileInput})
